import React from 'react';
import { v4 } from 'uuid';
import DocumentItemsFormElement, { DocumentItemsFormElementSharedProps } from './DocumentItemsFormElement';
import { fromBillItem, Item, DocumentAvailability } from '../models/item';
import { BillItems } from '../models/bill';

const makeItemFromCatalog = (newItem: Item, category: string): BillItems => ({
  costSubtotal: 0,
  costTotal: 0,
  createdBy: undefined,
  createdById: "",
  createdDate: "",
  employee: undefined,
  employeeId: "",
  bill: undefined,
  billId: "",
  isLocked: false,
  item: undefined,
  lastModifiedBy: undefined,
  lastModifiedById: "",
  lastModifiedDate: "",
  retailSubtotal: 0,
  retailTotal: 0,
  tax: 0,
  taxTotal: 0,
  vendor: undefined,
  brand: newItem.brand,
  category,
  costEach: newItem.costEach,
  description: newItem.description,
  id: v4(),
  itemId: newItem.id,
  quantity: 1,
  retailEach: newItem.retailEach,
  sku: newItem.sku,
  taxable: false,
  vendorId: newItem.vendorId,
});

const BillItemsFormElement: React.FC<DocumentItemsFormElementSharedProps<BillItems>> = (props) => (
  <DocumentItemsFormElement<BillItems>
    categoryNames={props.categoryNames}
    items={props.items}
    setItems={props.setItems}
    categoryButtonHandler={props.categoryButtonHandler}
    activeCategory={props.activeCategory}
    categoryEditMode={props.categoryEditMode}
    editCategoryName={props.editCategoryName}
    setEditCategoryName={props.setEditCategoryName}
    onAddClose={props.onAddClose}
    isAddOpen={props.isAddOpen}
    showCost
    showRetail
    costAlwaysEditable
    availableOn={DocumentAvailability.Bill}
    makeItemFromCatalog={makeItemFromCatalog}
    toCatalogItem={fromBillItem}
  />
);

export default BillItemsFormElement;
